import React from "react";
import "./AllVendorCard.css";
import RatingSvg from "../../components/svgs/RatingSvg";
import GradientButton from "../../../../components/button/Button";

interface VendorCardProps {
  image: string;
  name: string;
  category: string;
  price: string;
  vendor: string;
  description: string;
  reviews: number;
  avatar: string;
  userId?: string;
}

const AllVendorCard: React.FC<VendorCardProps> = ({
  image,
  name,
  category,
  price,
  vendor,
  description,
  reviews,
  avatar,
  userId,
}) => {
  return (
    <div className="all_vendors-card">
      <div className="all_vendors-card__image">
        <img src={image} alt={name} />
      </div>

      <div className="all_vendors-card__content">
        <h3 className="all_vendors-card__name">{name}</h3>
        <span className="all_vendors-card__category">{category}</span>

        <p className="all_vendors-card__price">
          <strong>{price}</strong> minimum order
        </p>

        {/* <div className="all_vendors-card__info">
          <img
            className="all_vendors-card__avatar"
            src={
              avatar ||
              "https://img.freepik.com/free-psd/3d-illustration-person-with-sunglasses_23-2149436188.jpg?uid=R27806234&ga=GA1.1.1994711177.1748430137&semt=ais_items_boosted&w=740"
            }
            alt={vendor}
          />
          <span className="all_vendors-card__vendor">{vendor}</span>
        </div> */}

        <p className="all_vendors-card__description">
          {description.toString().slice(0, 50) + "..."}
        </p>

        {/* <div className="all_vendors-card__rating">
          {[...Array(5)].map((_, index) => (
            <RatingSvg key={index} />
          ))}
          <span>({reviews} Reviews)</span>
        </div> */}

        <div style={{ width: "50%" }}>
          <GradientButton
            text="Shop Vendor"
            onClick={() =>
              (window.location.href = `/retail-single-vendor/${userId}`)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AllVendorCard;
